import * as React from "react"
import type { SVGProps } from "react"
const SvgProfile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5.85 17.24q1.28-.97 2.85-1.53a10 10 0 0 1 3.3-.57q1.73 0 3.3.56t2.85 1.54a8 8 0 0 0 1.36-2.32 8 8 0 0 0 .49-2.78q0-3.32-2.34-5.66T12 4.14c-3.33 0-4.1.78-5.66 2.34A7.7 7.7 0 0 0 4 12.14a7.8 7.8 0 0 0 1.85 5.1m6.15-4.1q-1.47 0-2.49-1.01A3.4 3.4 0 0 1 8.5 9.64q0-1.47 1.01-2.49a3.4 3.4 0 0 1 2.49-1q1.47 0 2.49 1c1.02 1 1.01 1.51 1.01 2.5q0 1.47-1.01 2.48A3.4 3.4 0 0 1 12 13.14m0 9a10 10 0 0 1-3.9-.78 10 10 0 0 1-3.17-2.14 10 10 0 0 1-2.14-3.18 10 10 0 0 1-.79-3.9q0-2.07.79-3.9a10 10 0 0 1 2.13-3.17Q6.28 3.7 8.1 2.93a10 10 0 0 1 3.9-.79q2.07 0 3.9.79a10 10 0 0 1 3.18 2.14q1.34 1.35 2.13 3.17a10 10 0 0 1 .79 3.9 10 10 0 0 1-.79 3.9 10 10 0 0 1-2.14 3.18q-1.34 1.35-3.17 2.14a10 10 0 0 1-3.9.78m0-2a8 8 0 0 0 4.65-1.5 8 8 0 0 0-2.15-1.11 8 8 0 0 0-2.5-.39 8 8 0 0 0-2.5.39q-1.17.39-2.15 1.11.98.73 2.15 1.12a8 8 0 0 0 2.5.38m0-9a1.46 1.46 0 0 0 1.5-1.5 1.46 1.46 0 0 0-1.5-1.5 1.45 1.45 0 0 0-1.5 1.5 1.46 1.46 0 0 0 1.5 1.5" />
  </svg>
)
export default SvgProfile
